import { EnClipType } from '../enum/en-clip-type';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IListItem, ISmartList, LogService } from '@medlogic/shared/shared-interfaces';
import { fadeAnimation } from '@medlogic/shared/utils';
import { ISmartListScore } from '../interface/ismart-list-score';

@Component({
  selector: 'ui-smart-list-score',
  templateUrl: './smart-list-score.component.html',
  styleUrls: ['./smart-list-score.component.css'],
  animations: [fadeAnimation]
})
export class SmartListScoreComponent implements OnInit {

  @Input() groups: ISmartList<ISmartListScore>[];
  @Input() search: string;
  @Input() enClipType = EnClipType.circle;

  @Output() itemClick = new EventEmitter<any>();

  constructor(
    private log: LogService
  ) { }

  ngOnInit() {
    try {

    } catch (error) {
      this.log.Registrar(this.constructor.name, 'ngOnInit', error.message);
    }
  }

  onItemClick(item: IListItem<any>): void {
    try {
      this.itemClick.emit(item);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onItemClick', error.message);
    }
  }


}
